module.exports = __webpack_public_path__ + "img/blue-banner-ph-1-mob.886f692f.png";